// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"lC-z","button":"mC-z","disabled":"nC-z"};